<div class="error-page d-flex align-items-center justify-content-center">
  <div class="card shadow-sm border-0 text-center error-card">
    <div class="card-body p-4 p-md-5">
      @if (logoUrl) {
        <img
          [src]="logoUrl"
          alt="Gateway3 Logo"
          class="error-logo mb-3"
          (error)="onLogoError()"
        />
      }
      @if (comingSoon) {
        <div class="error-code"><i class="bi bi-hourglass-split" aria-hidden="true"></i></div>
      } @else {
        <div class="error-code">{{ code }}</div>
      }
      <h2 class="error-title mb-2">{{ title }}</h2>
      <p class="error-message mb-4">{{ message }}</p>
      <a routerLink="/app" class="btn btn-primary btn-sm">Back to Home</a>
    </div>
  </div>
</div>
